<template>
  <div class="Score">
    <div class="info">
      <span v-text="trip.TripName"></span>
      <span v-text="'游玩天数：' + trip.TripDays + '（天）'"></span>
      <span v-text="'游玩人数：' + trip.TrousitCount + '（人）'"></span>
      <span v-text="'备案时间：' + trip.PostTime"></span>
      <span v-text="'开始时间：' + trip.StartTime"></span>
    </div>
    <div class="panel">
      <span class="title">您对本次旅行还满意吗？</span>
      <div class="row">
        <span>旅行社</span>
        <span v-text="corp.CompanyName"></span>
      </div>
      <div class="scoreRow">
        <span>评价：</span>
        <img
          v-for="item in 5"
          :src="corp.Score < item ? gStar : yStar"
          alt=""
          @click="ChangeCorpSocre(item)"
        />
      </div>

      <template v-for="(g, i) in guide">
        <div class="row">
          <span>导游</span>
          <span v-text="g.GuideName"></span>
        </div>
        <div class="scoreRow">
          <span>评价：</span>
          <img
            v-for="index in 5"
            :src="g.Score < index ? '' + gStar : yStar"
            alt=""
            @click="ChangeGuideSocre(i, index)"
          />
        </div>
      </template>

      <div class="submit" v-if="corp.ScoreId == null" @click="Submit">提交</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      yStar: require("../assets/yStar.png"),
      gStar: require("../assets/gStar.png"),
      corp: {},
      guide: [],
      tripId: "",
      trip: {}
    };
  },
  methods: {
    ChangeCorpSocre(index) {
      let _self = this;
      if (_self.corp.ScoreId != null) {
        return;
      }
      _self.corp.Score = index;
    },
    ChangeGuideSocre(i, index) {
      let _self = this;
      if (_self.corp.ScoreId != null) {
        return;
      }
      _self.guide[i].Score = index;
    },
    Submit() {
      let _self = this;

      if (_self.corp.Score < 1) {
        _self.$messagebox({
          title: "提示",
          message: "请为旅行社评分"
        });
        return;
      }

      try {
        _self.guide.forEach(item => {
          if (item.Score < 1) {
            throw new Error(item.GuideName);
          }
        });
      } catch (e) {
        _self.$messagebox({
          title: "提示",
          message: "请为" + e.toString().replace('Error: ','') + "导游评分"
        });
        return ;
      }

      _self
        .$messagebox({
          title: "提示",
          message: "您确定提交评价?",
          showCancelButton: true,
          closeOnClickModal: false
        })
        .then(action => {
          if (action === "confirm") {
            let param = {
              TripId: _self.tripId,
              Company: _self.corp,
              Guide: _self.guide
            };
            _self.axios
              .post("/api/tourist/Itineraries/PostEvaluate", param)
              .then(res => {
                _self.trip = res.data.trip;
                _self.corp = res.data.companyScore;
                _self.guide = res.data.guideScore;
              })
              .catch(err => {});
          }
        });
    },
    GetData() {
      let _self = this;
      let param = {
        tripId: _self.tripId
      };
      _self.axios
        .post("/api/tourist/Itineraries/GetItinerariesScore", param)
        .then(res => {
          _self.trip = res.data.trip;
          _self.corp = res.data.companyScore;
          _self.guide = res.data.guideScore;
        })
        .catch(err => {});
    }
  },
  mounted() {
    let _self = this;
    if (
      sessionStorage.getItem("Vue_TripId") == null &&
      _self.$route.params.tripId == null
    ) {
      _self.$router.push("/HomePage");
    } else {
      _self.tripId =
        _self.$route.params.tripId != null
          ? _self.$route.params.tripId
          : sessionStorage.getItem("Vue_TripId");
      _self.GetData();
    }
  }
};
</script>

<style lang="less" scoped>
.Score {
  width: 100%;
  min-height: 100%;
  background-image: url("../assets/home-bg.png");
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-color: #ddd;
  padding: 20px;
  box-sizing: border-box;

  .info {
    margin-top: 30px;
    width: 100%;
    display: flex;
    box-sizing: border-box;
    flex-wrap: wrap;
    color: #ffffff;

    span:nth-of-type(1) {
      width: 100%;
      font-size: 36px;
      font-weight: bold;
      letter-spacing: 3px;
      margin-bottom: 15px;
    }

    span:nth-of-type(n + 2) {
      width: 50%;
      font-size: 24px;
      letter-spacing: 2px;
    }

    span:nth-of-type(n + 4) {
      margin-top: 20px;
    }
  }

  .panel {
    margin-top: 50px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 40px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    .title {
      font-size: 36px;
      font-weight: bold;
      letter-spacing: 3px;
      color: #666666;
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
      box-sizing: border-box;
    }

    .row {
      margin-top: 60px;
      display: flex;
      flex-direction: column;

      span:nth-of-type(1) {
        font-size: 24px;
        letter-spacing: 2px;
        color: #666666;
      }
      span:nth-of-type(2) {
        margin-top: 10px;
        font-size: 36px;
        letter-spacing: 3px;
        color: #333333;
      }
    }
    .scoreRow {
      margin-top: 30px;
      display: flex;
      align-items: stretch;
      justify-content: space-between;

      span {
        font-size: 30px;
        letter-spacing: 2px;
        color: #16181e;
        display: flex;
        align-items: center;
      }
      img {
        width: 72px;
        height: 72px;
        text-align: center;
      }
    }

    .submit {
      margin-top: 50px;
      border-radius: 10px;
      text-align: center;
      background: #35b0fd;
      color: white;
      font-size: 30px;
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Score.vue